import React from "react";
import {
  CButton,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
  CModalFooter,
} from "@coreui/react";
import { DatePicker, Flex, Input, Select, Typography } from "antd";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { useState } from "react";
import {
  addAbonement,
  getAbonementsClient,
  commentsAction,
} from "src/store/Slices/ClientsSlice";
import { openNotification } from "src/components/helpers/notification";
import { useEffect } from "react";
import { getClientsList } from "src/store/Slices/ClientsSlice";

const AddComment = ({ commentModal, setCommentModal, clientInfo, payload }) => {
  const dateFormatList = ["DD.MM.YYYY"];
  // HELPERS
  const dispatch = useDispatch();
  dayjs.extend(customParseFormat);
  const yesterdayDate = dayjs().subtract(1, "day").format("DD.MM.YYYY");

  // STATE
  const [contactDate, setContactDate] = useState(dayjs());
  const [comment, setComment] = useState();
  const [task, setTask] = useState(dayjs());

  // FUNCTIONS
  const onClickAddComment = () => {
    if (comment === "") {
      openNotification({
        type: "error",
        message: `Поле "Комментарий" не может быть пустым`,
      });
    } else {
      dispatch(
        commentsAction({
          flag: "put",
          value: {
            userId: clientInfo.id,
            contactDate: dayjs(contactDate).format("YYYY-MM-DD"),
            comment: comment,
            ...(task && { task: dayjs(task).format("YYYY-MM-DD") }),
          },
        })
      ).then(() => {
        dispatch(
          commentsAction({ flag: "get", value: {UserId: clientInfo?.id}}),
        );
        
        dispatch(getClientsList(payload));
      
        setCommentModal(false);
      });
    }
  };

  useEffect(() => {
    setComment("");
    setTask();
  }, [commentModal]);

  return (
    <CModal
      alignment="center"
      visible={commentModal}
      aria-labelledby="VerticallyCenteredExample"
      onClose={() => {
        setCommentModal(false);
      }}
      keyboard={true}
    >
      <CModalHeader>
        <CModalTitle id="VerticallyCenteredExample">
          {"Добавить комментарий"}
        </CModalTitle>
      </CModalHeader>
      <CModalBody
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <Flex vertical gap={16} style={{ marginTop: "20px" }}>
          <>
            <div>
              <Typography.Title level={5}>Дата контакта</Typography.Title>
              <DatePicker
                style={{ width: "100%" }}
                format={"YYYY-MM-DD"}
                placement={"topRight"}
                onChange={(date) => {
                  setContactDate(date);
                }}
                value={contactDate}
              />
            </div>
            <div>
              <Typography.Title level={5}>Комментарий</Typography.Title>
              <Input
                defaultValue=""
                value={comment}
                onChange={(event) => {
                  setComment(event.target.value);
                }}
              />
            </div>
            <div>
              <Typography.Title level={5}>Задача</Typography.Title>
              <DatePicker
                style={{ width: "100%" }}
                format={"YYYY-MM-DD"}
                placement={"topRight"}
                onChange={(date) => {
                  setTask(date);
                }}
                value={task}
              />
            </div>
          </>
        </Flex>
      </CModalBody>
      <CModalFooter>
        <CButton
          onClick={() => {
            setCommentModal(false);
          }}
          style={{ color: "#fff" }}
          color="secondary"
        >
          Закрыть
        </CButton>
        <CButton onClick={onClickAddComment} style={{ color: "#fff" }}>
          Добавить
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default AddComment;
